import React, { useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { LoginContain, LoginFooter } from "../../style/Login/Newpassword";
import Logo from "../../assets/images/logo.png";
import seePasswordIcon from "../../assets/images/icons/eye.png";
import hidePasswordIcon from "../../assets/images/icons/eye1.png";
import { Loader } from "../../utils/loader";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { ResetPassword } from "../../services/authServices";

function Newpassword() {
  const [open, setOpen] = useState(false);
  const [loading, setLoading] = useState(false);
  const [errors, setErrors] = useState({});
  const [showPasswordRequirements, setShowPasswordRequirements] = useState(false);
  const navigate = useNavigate();
  const [formValues, setFormValues] = useState({
    password: "",
    confirmPassword: "",
  });

  const location = useLocation();
  const payloadData = location?.state?.data;

  // Password validation checks
  const hasMinLength = formValues.password.length >= 8;
  const hasUpperCase = /[A-Z]/.test(formValues.password);
  const hasLowerCase = /[a-z]/.test(formValues.password);
  const hasDigit = /\d/.test(formValues.password);
  const hasSpecialChar = /[@$!%*?&]/.test(formValues.password);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormValues((prevValues) => ({
      ...prevValues,
      [name]: value,
    }));

    if (name === "confirmPassword") {
      if (value !== formValues.password) {
        setErrors((prevErrors) => ({
          ...prevErrors,
          confirmPassword: "Passwords do not match",
        }));
      } else {
        setErrors((prevErrors) => {
          const { confirmPassword, ...rest } = prevErrors;
          return rest;
        });
      }
    }
  };

  const validateForm = () => {
    let formErrors = {};

    if (!formValues.password) {
      formErrors.password = "Password is required";
    } else if (!hasMinLength || !hasUpperCase || !hasLowerCase || !hasDigit || !hasSpecialChar) {
      formErrors.password = "Password does not meet security requirements";
    }

    if (!formValues.confirmPassword) {
      formErrors.confirmPassword = "Confirm password is required";
    } else if (formValues.password !== formValues.confirmPassword) {
      formErrors.confirmPassword = "Passwords do not match";
    }

    setErrors(formErrors);
    return Object.keys(formErrors).length === 0;
  };

  const changePassword = async (e) => {
    e.preventDefault();
    if (!payloadData || !payloadData.adminId || !payloadData.OTP) {
      toast.error("Invalid or missing password reset data.");
      return;
    }

    try {
      if (validateForm()) {
        setLoading(true);
        const payload = {
          adminId: payloadData.adminId,
          OTP: payloadData.OTP,
          password: formValues.password,
        };
        const res = await ResetPassword(payload);
        if (res && res.success) {
          toast.success("Password reset successfully");
          setTimeout(() => navigate("/admin-login"), 2000);
        } else {
          toast.error("Failed to reset password.");
        }
      }
    } catch (error) {
      console.log("Error: ", error);
      toast.error(error?.response?.data?.error ?? "Something went wrong");
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <LoginContain>
        <div className="LoginCard">
          <div className="LoginLogo">
            <img src={Logo} alt="logo"  loading="lazy"/>
          </div>
          <div className="LoginTitle">
            <h4>Reset Password</h4>
            <p>Please create your new password!</p>
          </div>
          <form onSubmit={changePassword}>
            <div className="LoginGroup">
              <label htmlFor="password" className="forgot-label">
                Enter New Password
              </label>
              <div className="password-container">
                <input
                  type={open ? "text" : "password"}
                  id="password"
                  name="password"
                  value={formValues.password}
                  placeholder="Enter new password"
                  onChange={handleChange}
                  onFocus={() => setShowPasswordRequirements(true)}
                  onBlur={() => setShowPasswordRequirements(false)}
                />
                <img
                  src={open ? hidePasswordIcon : seePasswordIcon}
                  alt="Toggle visibility"
                  className="password-toggle-icon"
                  onClick={() => setOpen(!open)}
                   loading="lazy"
                />
                {/* New tooltip requirements */}
                {showPasswordRequirements && (
                  <div className="password-tooltip">
                    <h5>Password must contain:</h5>
                    <ul>
                      <li className={hasMinLength ? "requirement-met" : ""}>
                        At least 8 characters
                      </li>
                      <li className={hasUpperCase ? "requirement-met" : ""}>
                        At least one uppercase letter (A-Z)
                      </li>
                      <li className={hasLowerCase ? "requirement-met" : ""}>
                        At least one lowercase letter (a-z)
                      </li>
                      <li className={hasDigit ? "requirement-met" : ""}>
                        At least one number (0-9)
                      </li>
                      <li className={hasSpecialChar ? "requirement-met" : ""}>
                        At least one special character (@$!%*?&)
                      </li>
                    </ul>
                  </div>
                )}
              </div>
              {errors.password && <div className="error">{errors.password}</div>}
            </div>

            <div className="LoginGroup">
              <label htmlFor="confirmPassword" className="forgot-label">
                Confirm Password
              </label>
              <div className="password-container">
                <input
                  type={open ? "text" : "password"}
                  id="confirmPassword"
                  name="confirmPassword"
                  value={formValues.confirmPassword}
                  placeholder="Confirm password"
                  onChange={handleChange}
                />
                <img
                  src={open ? hidePasswordIcon : seePasswordIcon}
                  alt="Toggle visibility"
                  className="password-toggle-icon"
                  onClick={() => setOpen(!open)}
                   loading="lazy"
                />
              </div>
              {errors.confirmPassword && (
                <div className="error">{errors.confirmPassword}</div>
              )}
            </div>

            <div className="LoginGroup LoginBtn">
              <button type="submit" disabled={loading}>
                {loading ? <Loader /> : "Reset Password"}
              </button>
            </div>
          </form>
        </div>
        <ToastContainer />
      </LoginContain>

      <LoginFooter>
        <p>
          POWERED BY: <span>Manthan IT Solutions</span>
        </p>
      </LoginFooter>
    </>
  );
}

export default Newpassword;